import type { PlanTier } from "../types"

// `platform` and `scale` are the pre-rename names for the two self-serve tiers.
// The backend still returns them for organizations that predate the rename, so
// every tier decision normalizes first rather than testing for both spellings.
const LEGACY_TIER_NAMES: Partial<Record<string, PlanTier>> = {
  platform: "starter",
  scale: "growth",
}

/** The current name for a tier, so a legacy organization is treated as its tier. */
export function canonicalTier(tier: PlanTier): PlanTier {
  return LEGACY_TIER_NAMES[tier] ?? tier
}

// Display-name mapping for billing tiers. Handles both canonical
// (`starter`/`growth`) and legacy (`platform`/`scale`) names the backend may return.
export function tierLabel(tier: string | null | undefined): string {
  if (tier === null || tier === undefined || tier === "") {
    return "—"
  }
  const normalized = LEGACY_TIER_NAMES[tier.toLowerCase()] ?? tier.toLowerCase()
  switch (normalized) {
    case "starter":
      return "Starter"
    case "growth":
      return "Growth"
    case "enterprise":
      return "Enterprise"
    case "telnyx_partner":
      return "Telnyx Partner"
    default:
      // Fallback: TitleCase whatever the backend sent so we never blank a
      // surface on a status we haven't seen.
      return normalized.charAt(0).toUpperCase() + normalized.slice(1)
  }
}
